/* RESPONSIBLE TEAM: team-automation-foundations */
import Model, { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';

export default class EscalationPredicates extends Model {
  @attr('string') declare appId: string;
  @fragment('predicates/predicate-group') declare predicateGroup: any;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ai-agent/escalation-predicates': EscalationPredicates;
  }
}
